var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-column-select", {
                    attrs: {
                      value: _vm.value.Field,
                      model: _vm.model,
                      "is-filter": "",
                      browse: _vm.browse,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onField($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.selectedField && !_vm.isNamedFilter
        ? _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      !_vm.isBoolean
                        ? _c("w-select", {
                            attrs: {
                              label: _vm.$ct("operator"),
                              items: _vm.operators,
                              fancy: "",
                            },
                            model: {
                              value: _vm.value.Operator,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "Operator", $$v)
                              },
                              expression: "value.Operator",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  !_vm.removeIsOrOption
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("is-or") },
                            model: {
                              value: _vm.value.IsOr,
                              callback: function ($$v) {
                                _vm.$set(_vm.value, "IsOr", $$v)
                              },
                              expression: "value.IsOr",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("app-human-filter-edit-value", {
                attrs: {
                  xs: "12",
                  md: "6",
                  filter: _vm.value,
                  "field-type": _vm.fieldType,
                  model: _vm.model,
                },
              }),
            ],
            1
          )
        : _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              !_vm.removeIsOrOption
                ? _c("w-checkbox", {
                    attrs: { label: _vm.$ct("is-or") },
                    model: {
                      value: _vm.value.IsOr,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "IsOr", $$v)
                      },
                      expression: "value.IsOr",
                    },
                  })
                : _vm._e(),
              _c("app-custom-filter-selector", {
                attrs: { model: _vm.model, value: _vm.value },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }